import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Checkbox, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { HAvatar } from "../avatar";
export const InvitationPersonelCard = ({ control, name, }) => {
    return (_jsx(Box, { sx: {
            boxShadow: " 0px 4px 8px 0px #919EAB29",
            px: 1,
            pu: 0.5,
            borderRadius: 1.5,
            background: " #FFFFFF",
            mt: 1
        }, children: _jsxs(Grid, { container: true, spacing: 2, children: [_jsx(Grid, { size: "auto", children: _jsx(HAvatar, { name: name }) }), _jsxs(Grid, { size: "grow", children: [_jsx(Typography, { variant: "subtitle1", color: "text.primary", children: name }), _jsx(Typography, { variant: "subtitle2", color: "text.secondary", children: "Smit Elektrotechniek" })] }), _jsx(Grid, { size: "auto", children: _jsx(Checkbox, {}) })] }) }));
};
